import { localId } from 'src/app/helpers/local-id';

export class ElementHistoryLog {
  public readonly id = localId();

  public constructor(
    public responsible: string,
    public comments: string,
    public date?: Date
  ) {}
}
